var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27",
    "data-name": "Layer 27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.14,28.43c12-7.24,7.07-25.76-7.14-25.91-14.21.15-19.15,18.69-7.13,25.92A26.47,26.47,0,0,0,5.58,53.88c0,9.13,5.09,8.78,12.45,5.28,10.69-5,17.3-4.95,28,0,6.73,3.19,12.53,4.3,12.44-5.28A26.48,26.48,0,0,0,39.14,28.43Zm-18.09-12A11,11,0,0,1,32,5.52c14.53.6,14.52,21.3,0,21.9A11,11,0,0,1,21.05,16.47ZM54.39,58.3c-1.09.72-4.2-.61-7.21-1.9-4.2-1.79-9.42-4-15.17-4s-11,2.23-15.16,4c-3,1.29-6.13,2.62-7.21,1.9-.4-.26-1.06-1.18-1.06-4.42a23.43,23.43,0,1,1,46.86,0C55.44,57.12,54.79,58,54.39,58.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.2067ceef98cdd48bd7d869c254fb4bac.svg";
export { ForwardRef as ReactComponent };